// extracted by mini-css-extract-plugin
export var container = "_ag-0";
export var content = "_ag-3";
export var customerTitle = "_ag-4";
export var empty = "_ag-5";
export var gray = "_ag-6";
export var header = "_ag-7";
export var info = "_ag-8";
export var loading = "_ag-2";
export var loadingCard = "_ag-9";
export var oneLine = "_ag-a";
export var personName = "_ag-e";
export var pillContainer = "_ag-b";
export var selected = "_ag-1";
export var text = "_ag-c";
export var twoLines = "_ag-d";
export var unread = "_ag-f";
export var unreadIndicator = "_ag-g";